import shellTemplate from './Shell.html';
import './Shell.scss';

/** Points de montage exposés par le shell pour les vues qu'il héberge. */
export interface ShellMounts {
	/** Racine du formulaire d'ajout (URL directe + recherche de chaîne). */
	downloadFormRoot: HTMLElement;
	/** Racine du panneau de file d'attente. */
	queuePanelRoot: HTMLElement;
}

/**
 * Monte la coquille (shell) de l'application dans l'élément racine fourni.
 *
 * @param root - Élément DOM dans lequel injecter le gabarit du shell.
 * @returns Les points de montage des vues hébergées par le shell.
 * @throws {Error} Si le gabarit ne contient pas les points de montage attendus.
 */
export function mountShell(root: HTMLElement): ShellMounts {
	root.innerHTML = shellTemplate;

	const downloadFormRoot = root.querySelector<HTMLElement>('#download-form');
	const queuePanelRoot = root.querySelector<HTMLElement>('#queue-panel');
	if (!downloadFormRoot || !queuePanelRoot) {
		throw new Error('Gabarit du shell invalide : points de montage introuvables.');
	}

	return { downloadFormRoot, queuePanelRoot };
}
